import WeatherDataActions from "./WeatherData.actions";

export interface StateWeatherData {
	isLoading: boolean;
	weatherData: WeatherReduxType[] | null;
}

export const defaultState: StateWeatherData = {
	isLoading: false,
	weatherData: null,
};

type WeatherDataActionTypes = ReturnType<typeof WeatherDataActions.SET_IS_LOADING.action>
	| ReturnType<typeof WeatherDataActions.SET_WEATHER_DATA.action>
	| ReturnType<typeof WeatherDataActions.ADD_WEATHER_DATA.action>
	| ReturnType<typeof WeatherDataActions.REMOVE_WEATHER_DATA.action>;

export default (
	state: StateWeatherData = defaultState,
	action: WeatherDataActionTypes,
): StateWeatherData => {
	switch (action.type) {
		case WeatherDataActions.SET_IS_LOADING.ACTION:
			return {
				...state,
				isLoading: action.payload,
			};

		case WeatherDataActions.SET_WEATHER_DATA.ACTION: {
			const weatherData = action.payload;
			if (!weatherData) {
				return {
					...state,
				};
			}

			return {
				...state,
				weatherData: weatherData.sort((a, b) => {
					return b.timestamp - a.timestamp;
				}),
			};
		}

		case WeatherDataActions.ADD_WEATHER_DATA.ACTION: {
			const currentWeatherData = state.weatherData ?? [];
			const newWeatherData = action.payload.filter((entry) => {
				return !currentWeatherData.some((existingEntry) => existingEntry.id === entry.id);
			});
			const updatedWeatherData = [...currentWeatherData, ...newWeatherData].sort((a, b) => {
				return b.timestamp - a.timestamp;
			});

			return {
				...state,
				weatherData: updatedWeatherData,
			};
		}

		case WeatherDataActions.REMOVE_WEATHER_DATA.ACTION: {
			const weatherDataToRemove = action.payload;

			if (!weatherDataToRemove) {
				return {
					...state,
					weatherData: null,
				};
			}

			const currentWeatherData = state.weatherData ?? [];
			const updatedWeatherData = currentWeatherData.filter((entry) => weatherDataToRemove.includes(entry.id));

			return {
				...state,
				weatherData: updatedWeatherData,
			};
		}

		default:
			return state;
	}
};
